import { useQuery } from '@apollo/client'
import { isAuthenticated, useCurrentUser } from 'auth'

import { gql } from 'graphql-generated'
import { PublicProfileQueryQuery } from 'graphql-generated/graphql'

const PUBLIC_PROFILE_QUERY = gql(`
  query PublicProfileQuery($userId: Int!, $withEmail: Boolean!) {
    user: auth_user_by_pk(id: $userId) {
      ...PublicProfile_Profile
      ...PublicProfile_Contributions
    }
  }
`)

type UsePublicProfileResult =
  | { loading: true; user: undefined }
  | { loading: false; user: NonNullable<PublicProfileQueryQuery['user']> }

export default function usePublicProfile(
  userId: number
): UsePublicProfileResult {
  const currentUser = useCurrentUser()

  const { data, loading, error } = useQuery(PUBLIC_PROFILE_QUERY, {
    fetchPolicy: 'cache-and-network',
    variables: { userId, withEmail: isAuthenticated(currentUser) },
  })

  if (error) {
    throw error
  }

  if (loading) {
    return { loading, user: undefined }
  }

  const user = data?.user

  if (user) {
    return { loading, user }
  }

  throw new Error('Failed to load user')
}
